import { Image, Linking, Platform, StyleSheet } from 'react-native'

import { useB2C } from '@zet/common/hooks/useB2C'
import { useNavigation } from '@zet/common/hooks/useNavigation'
import { MY_TEAMS_ADVISOR } from '@zet/constants'
import Pressable from '@zet/design-system/pressable'
import { APP_NAME } from '@zet/end-points'
import { DEVICE_WIDTH } from '@zet/utils/Constants'
import { isCustomerFlow } from '@zet/utils/isCustomerFlow'

import { OtherCategorie } from '../../hooks/useBrandRecommendations'
import useFilterStore from '../../hooks/useFilterStore'
import useGetCategoryBanner from '../../hooks/useGetCategoryBanner'
import { parseCMSScreenOptions } from '../../utils'
import { REDIRECTION_LINK } from '../../utils/constants'
import CategoryFilter from './CategoryFilter'
import FilterBar from './filterBar'

type FilterContainerProps = {
  categoryId: number
  customerId?: number
  isRecommendationFlow: boolean
  isBMSFlow: boolean
  isJfsFlow: boolean
  otherCategories?: Array<OtherCategorie>
  isCategoryInEligible?: boolean
  selectedCategory: {
    categoryId: string | number
    categoryName: string
    totalCount: number
  }
}

const FilterContainer = ({
  isCategoryInEligible,
  categoryId,
  customerId,
  isRecommendationFlow,
  otherCategories,
  selectedCategory,
  isBMSFlow,
  isJfsFlow,
}: FilterContainerProps) => {
  const setCategoryId = useFilterStore((state) => state?.setCategoryId)
  const { data } = useGetCategoryBanner({ categoryId })
  const { navigate } = useNavigation()

  const topStrap = data?.media_for_the_banner?.image?.url
  const screenName = data?.media_for_the_banner?.redirect_to_screen
  const options = data?.media_for_the_banner?.screenOptions

  const isWeb = Platform.OS === 'web'

  const { isB2C, b2cRewardType } = useB2C()

  const handleBannerClick = () => {
    if (screenName) {
      if (screenName === REDIRECTION_LINK) {
        Linking.openURL(options?.url)
      } else {
        navigate(screenName, parseCMSScreenOptions(options))
      }
    }
  }

  return (
    <>
      {!isB2C &&
        isCustomerFlow() &&
        otherCategories &&
        isRecommendationFlow &&
        !isBMSFlow &&
        !isJfsFlow && (
          <CategoryFilter
            handlePress={setCategoryId}
            data={otherCategories}
            selectedCategory={selectedCategory}
          />
        )}

      {!isCategoryInEligible && (
        <FilterBar
          categoryId={categoryId}
          customerId={customerId}
          isBMSFlow={isBMSFlow}
          isJfsFlow={isJfsFlow}
        />
      )}

      {!isWeb && APP_NAME !== MY_TEAMS_ADVISOR && topStrap ? (
        <Pressable style={styles.strapContainer} onPress={handleBannerClick}>
          <Image
            style={styles.strapImg}
            resizeMode="contain"
            source={{ uri: topStrap }}
          />
        </Pressable>
      ) : null}

      {/* {isB2C && (
        <XStack className="items-center bg-[#FFF1A9] px-3 py-2">
          <Icon type="Gift" color="#4C3508" />
          <SH4 className="ml-2">
            {b2cRewardType === 'amazon' ? (
              <>
                {i18n.t('brandPage.reward.amazon.prefix')}
                <B4>{i18n.t('brandPage.reward.amazon.amount')}</B4>
                {i18n.t('brandPage.reward.amazon.suffix')}
              </>
            ) : (
              <>
                {i18n.t('brandPage.reward.zetCoins.prefix')}
                <B4>{i18n.t('brandPage.reward.zetCoins.amount')}</B4>
                {i18n.t('brandPage.reward.zetCoins.suffix')}
              </>
            )}
          </SH4>
        </XStack>
      )} */}
    </>
  )
}

export default FilterContainer

const styles = StyleSheet.create({
  strapContainer: {
    width: DEVICE_WIDTH,
    height: 58,
    marginBottom: 10,
    marginTop: -2,
  },
  strapImg: {
    width: '100%',
    height: '100%',
  },
})
